import React from 'react'
import {
  AlignItems,
  Bold,
  Box,
  Color,
  Display,
  FontFamily,
  FontWeight,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

import { formatPrice } from './orderSummaryPricing'

type ValueBannerProps = {
  averageCostPerPortion?: string
}

const formatPositivePrice = (price?: string) => {
  const priceValue = Number(price)

  if (!Number.isFinite(priceValue) || priceValue <= 0) {
    return null
  }

  return formatPrice(price)
}

export const ValueBanner = ({ averageCostPerPortion }: ValueBannerProps) => {
  const formattedPortionCost = formatPositivePrice(averageCostPerPortion)

  if (!formattedPortionCost) {
    return null
  }

  return (
    <Box
      data-testid="value-banner"
      bg={Color.Success_50}
      color={Color.Success_900}
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={2}
      paddingH={4}
      paddingV={3}
      style={{ borderRadius: '8px' }}
    >
      <Icon name="offer_pound" size={8} variant={IconVariant.Inherit} />
      <Text
        size={4}
        color={Color.ColdGrey_800}
        fontFamily={FontFamily.Bold}
        fontWeight={FontWeight.Bold}
      >
        Only <Bold color={Color.Success_900}>{formattedPortionCost}</Bold> per portion on average
      </Text>
    </Box>
  )
}
